import { EXCEPTION_SALE_TYPE_LIST, useCatalogProductIdParams } from '@domains/pdp-common';

import { useContactInfo } from '../queries/useContactInfoQuery';

export const usePolicyResponsibilityService = () => {
  const country = 'KR';
  const isHide = country !== 'KR';

  const param = useCatalogProductIdParams();
  const { shop } = useContactInfo(param);

  const displayPolicyResponsibility = !EXCEPTION_SALE_TYPE_LIST.has(shop.sale_type ?? '');

  return {
    isHide,
    displayPolicyResponsibility,
  };
};
